export default "__VITE_PUBLIC_ASSET__d637bf41__"